/**
 * Cloudinary transformation params that generally should be
 * applied to all images. These are applied in the CloudinaryImage
 * component, but can be used separately to build <Transform> tags.
 */
export const defaultTransformationParams = {
  crop: 'fill',
  quality: 'auto',
  format: 'auto',
  dpr: '2',
};
